import React, { useEffect, useState, useRef } from 'react';
interface CountdownTimerProps {
  className?: string;
  boxClassName?: string;
  textClassName?: string;
  labelClassName?: string;
}
function getEndTime(): number {
  const saved = localStorage.getItem('megapack_countdown_end');
  if (saved) {
    const t = parseInt(saved, 10);
    if (t > Date.now()) return t;
  }
  const t = Date.now() + 23 * 3600000 + 58 * 60000 + 33000;
  localStorage.setItem('megapack_countdown_end', t.toString());
  return t;
}
export function CountdownTimer({
  className = 'flex gap-4 justify-center',
  boxClassName = 'bg-brand-dark border border-brand-border rounded-xl p-4 min-w-[90px] flex flex-col items-center',
  textClassName = 'text-5xl font-heading font-bold text-brand-accent',
  labelClassName = 'text-xs uppercase tracking-widest text-white/50 mt-2 font-badge font-bold'
}: CountdownTimerProps) {
  const endTimeRef = useRef(getEndTime());
  const [display, setDisplay] = useState(() => {
    const d = endTimeRef.current - Date.now();
    if (d <= 0) return {
      h: '00',
      m: '00',
      s: '00'
    };
    return {
      h: String(Math.floor(d / 3600000 % 24)).padStart(2, '0'),
      m: String(Math.floor(d / 60000 % 60)).padStart(2, '0'),
      s: String(Math.floor(d / 1000 % 60)).padStart(2, '0')
    };
  });
  useEffect(() => {
    const timer = setInterval(() => {
      const d = endTimeRef.current - Date.now();
      if (d <= 0) {
        setDisplay({
          h: '00',
          m: '00',
          s: '00'
        });
        return;
      }
      setDisplay({
        h: String(Math.floor(d / 3600000 % 24)).padStart(2, '0'),
        m: String(Math.floor(d / 60000 % 60)).padStart(2, '0'),
        s: String(Math.floor(d / 1000 % 60)).padStart(2, '0')
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className={className} data-id="element-61">
      <div className={boxClassName} data-id="element-62">
        <span className={textClassName} data-id="element-63">{display.h}</span>
        <span className={labelClassName} data-id="element-64">hs</span>
      </div>
      <div className="text-5xl font-bold text-white/50 self-start mt-3" data-id="element-65">:</div>
      <div className={boxClassName} data-id="element-66">
        <span className={textClassName} data-id="element-67">{display.m}</span>
        <span className={labelClassName} data-id="element-68">min</span>
      </div>
      <div className="text-5xl font-bold text-white/50 self-start mt-3" data-id="element-69">:</div>
      <div className={boxClassName} data-id="element-70">
        <span className={textClassName} data-id="element-71">{display.s}</span>
        <span className={labelClassName} data-id="element-72">seg</span>
      </div>
    </div>;
}